import GraphemeSplitter from "grapheme-splitter";
var MAX_CATEGORY_NAME_FIRST_WORD_LENGTH = 18;
var MAX_CATEGORY_NAME_LENGTH = 30;
export var filterLongCategoryName = function(name) {
    var firstWord = name === null || name === void 0 ? void 0 : name.substring(0, name.indexOf(" "));
    return name !== undefined && firstWord !== undefined && categoryNameLength(firstWord) > MAX_CATEGORY_NAME_FIRST_WORD_LENGTH ? firstWord : name;
};
export var isLongCategoryName = function(name) {
    var filteredName = filterLongCategoryName(name);
    return categoryNameLength(filteredName) > MAX_CATEGORY_NAME_LENGTH && (filteredName === null || filteredName === void 0 ? void 0 : filteredName.includes(" "));
};
var categoryNameLength = function(name) {
    return name ? new GraphemeSplitter().splitGraphemes(name).length : 0;
};
